module.exports = __webpack_public_path__ + "img/sec2_4_m.c4d41199.png";